<div class="gcontainer bwhite">
  <div class="row g-4">
    <div class="col-md-3 col-12">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active breadcrumb cursor" aria-current="page"
            (click)="reDirectUrl('dashboard')" (keypress)="reDirectUrl('dashboard')" tabindex="0">
            Dashboard
          </li>
          <li class="breadcrumb-item active breadcrumb cursor" aria-current="page"
            (click)="reDirectUrl('mixDesignDashboard')" (keypress)="reDirectUrl('mixDesignDashboard')">
            Mix Design Dashboard
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ isEditMode ? 'Client / Edit' : 'Client / New' }}
          </li>
        </ol>
      </nav>

      <h1 class="mat-h1">Client Mix Design{{ mixReferenceId ? ' : ' + mixReferenceId : '' }}</h1>
    </div>
    <div class="col-md-1 d-none d-md-block gap-col"></div>
    <div class="col-md col-12">
      <div class="row">
        <div class="col-md-4 pt-16">
          <mat-card class="shadow-none">
            <mat-card-content>
              <div class="row">
                <div class="col-md-4">
                  <div class="font-12 text-center">Total Water</div>
                  <h1 class="mb-0 text-center">{{ totalWater }}</h1>
                </div>
                <div class="col-md-4">
                  <div class="font-12 text-center">Total Dry Weight</div>
                  <h1 class="mb-0 text-center">{{ totalDryWeight }}</h1>
                </div>
                <div class="col-md-4">
                  <div class="font-12 text-center">Total Cementitious</div>
                  <h1 class="mb-0 text-center">{{ totalCementitious }}</h1>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-8 pt-16">
          <mat-card class="shadow-none">
            <mat-card-content>
              <div class="row">
                <div class="col-md-2" style="padding-right: 5px;">
                  <div class="font-12 text-center">Water / Cement Ratio</div>
                  <h1 class="card-count mb-0 text-center">{{ waterCementRatio }}</h1>
                </div>
                <div class="col-md-3">
                  <div class="font-12 text-center">Compressive Strength(psi)</div>
                  <h1 class="card-count mb-0 text-center">{{ compressiveStrength }}</h1>
                </div>
                <div class="col-md-3">
                  <div class="font-12 text-center">Moisture Content (%)</div>
                  <h1 class="card-count mb-0 text-center">{{ moistureContent }}</h1>
                </div>
                <div class="col-md-2">
                  <div class="font-12 text-center">Dry Density (lb/yd³)</div>
                  <h1 class="card-count mb-0 text-center">{{ dryDensity }}</h1>
                </div>
                <div class="col-md-2">
                  <div class="font-12 text-center">Air Content (%)</div>
                  <h1 class="card-count mb-0 text-center">{{ myForm.get('airContent')?.value || '-' }}</h1>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="myForm">
    <div class="row g-4">
      <div class="col-md-3 col-12">
        <div class="row">
          <div class="col-md-6 col-12">
            <mat-label class="mat-label">
              {{ getLabel('mixId') }}
              @if (isRequired('mixId')) {
                <span class="required">*</span>
              }
            </mat-label>
            <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
              <input matInput formControlName="mixId"/>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-12">
            <mat-label class="mat-label">
              Geotherm Reference Mix ID
              @if (isRequired('geothermReferenceMixId')) {
                <span class="required">*</span>
              }
            </mat-label>
            <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
              <input matInput formControlName="geothermReferenceMixId"/>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-12">
            <mat-label class="mat-label">
              {{ getLabel('materialType') }}
              @if (isRequired('materialType')) {
                <span class="required">*</span>
              }
            </mat-label>
            <mat-form-field appearance="outline" class="mat-form-field-width">
              <input
                matInput
                formControlName="materialType"
                [matAutocomplete]="auto"
                />
                <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
                  @for (option of materialOptions; track option) {
                    <mat-option [value]="option">
                      {{ option }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                Plant
                @if (isRequired('plant')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                <input matInput formControlName="plant"/>
              </mat-form-field>
            </div>
          </div>

          <div>
            <mat-label class="mat-label">
              {{ getLabel('note') }}
              @if (isRequired('note')) {
                <span class="required">*</span>
              }
            </mat-label>
            <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
              <input matInput formControlName="note"/>
            </mat-form-field>
          </div>

          <div class="row">
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('countryId') }}
                @if (isRequired('countryId')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width">
                <mat-select
                  (selectionChange)="getStates($safeNavigationMigration(myForm.get('countryId')?.value))"
                  formControlName="countryId">
                  @for (country of countries; track country) {
                    <mat-option [value]="country.id">{{ country.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('stateId') }}
                @if (isRequired('stateId')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width">
                <mat-select
                  (selectionChange)="getCities($safeNavigationMigration(myForm.get('stateId')?.value))"
                  formControlName="stateId">
                  @for (state of states; track state) {
                    <mat-option [value]="state.id">{{ state.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('cityId') }}
                @if (isRequired('cityId')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width">
                <mat-select formControlName="cityId">
                  @for (city of cities; track city) {
                    <mat-option [value]="city.id" class="arrow">{{ city.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('zipcode') }}
                @if (isRequired('zipcode')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                <input matInput formControlName="zipcode"/>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('companyName') }}
                @if (isRequired('companyName')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                <input matInput formControlName="companyName"/>
              </mat-form-field>
            </div>
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('contactName') }}
                @if (isRequired('contactName')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                <input matInput formControlName="contactName"/>
              </mat-form-field>
            </div>
          </div>

          <mat-label class="mat-label">
            {{ getLabel('projectName') }}
            @if (isRequired('projectName')) {
              <span class="required">*</span>
            }
          </mat-label>
          <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
            <input matInput formControlName="projectName"/>
          </mat-form-field>

          <div class="row">
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('strength') }} <span class="unit-text">(psi)</span>
                @if (isRequired('strength')) {
                  <span class="required">*</span>
                }
                <a class="grapgh-link" href="javascript:void(0)" (click)="openStrengthPopup()" style="margin-left: 8px; font-size: 0.9em;">
                  W/C Ratio
                </a>
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                <input matInput formControlName="strength"/>
              </mat-form-field>
            </div>

            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('slump') }} <span class="unit-text">(inches)</span>
                @if (isRequired('slump')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                <input matInput formControlName="slump"/>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('thermalSpecification') }}
                @if (isRequired('thermalSpecification')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                <input matInput formControlName="thermalSpecification"/>
              </mat-form-field>
            </div>

            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                {{ getLabel('timeOfEfflux') }} <span class="unit-text">(seconds)</span>
                @if (isRequired('timeOfEfflux')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                <input matInput type="number" formControlName="timeOfEfflux"/>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                Air Content <span class="unit-text">(%)</span>
                @if (isRequired('airContent')) {
                  <span class="required">*</span>
                }
              </mat-label>
              <mat-form-field appearance="outline" class="mat-form-field-width" hideRequiredMarker>
                <input matInput type="number" formControlName="airContent"/>
              </mat-form-field>
            </div>

            <div class="col-md-6 col-12">
              <mat-label class="mat-label">
                Date@if (isRequired('airContent')) {
                <span class="required">*</span>
              }
            </mat-label>
            <mat-form-field appearance="outline" class="mat-form-field-width">
              <input
                formControlName="date"
                [max]="currentDate"
                class="mat-date-input"
                readonly
                matInput
                [matDatepicker]="picker" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="col-md-1 d-none d-md-block gap-col"></div>
        <div class="col-md col-12">
          <div class="table-wrapper">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z1 material-table">

              <ng-container matColumnDef="materialType">
                <th mat-header-cell *matHeaderCellDef>Component Material Type *</th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                  <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label">
                    <mat-select formControlName="materialType">
                      @for (type of materialTypes; track type) {
                        <mat-option [value]="type">
                          {{ type }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </td>
              </ng-container>

              <ng-container matColumnDef="supplier">
                <th mat-header-cell *matHeaderCellDef>Supplier Name</th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                  <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label">
                    <input matInput formControlName="supplier"/>
                  </mat-form-field>
                </td>
              </ng-container>

              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>Supplier Material Name *</th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                  <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label">
                    <input matInput formControlName="description"/>
                  </mat-form-field>
                </td>
              </ng-container>

              <ng-container matColumnDef="weight">
                <th mat-header-cell *matHeaderCellDef class="center-header">
                  Weight <span class="unit-text">(lb/yd³)</span> *
                </th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                  <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label" style="position: relative;">
                    <input
                      matInput
                      type="number"
                      formControlName="weight"
                      />
                      @if (row.get('materialType')?.value === 'Add Mixer') {
                        <span
                          style="position: absolute; right: 5px; top: 45%; transform: translateY(-45%); font-size: 1rem; color: rgba(0,0,0,0.6); pointer-events: none;"
                          >
                          oz/yd³
                        </span>
                      }
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="gravity">
                  <th mat-header-cell *matHeaderCellDef>Specific Gravity</th>
                  <td mat-cell *matCellDef="let row" [formGroup]="row">
                    <mat-form-field appearance="outline" class="mat-form-field-width mat-no-label">
                      <input matInput type="number" formControlName="gravity"/>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>Actions</th>
                  <td mat-cell *matCellDef="let row; let i = index">
                    <button mat-icon-button class="gray-icon-button" (click)="removeRow(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>

              <div class="mt-2">
                <button mat-raised-button type="button" (click)="addMaterialRow()">Add Component Material</button>
              </div>
              <div class="mt-3" style="display: flex; justify-content: flex-end; gap: 10px;">
                <button mat-raised-button class="cancel-btn" (click)="cancel()">Cancel</button>
                <button mat-flat-button color="primary" type="submit" [disabled]="myForm.invalid" (click)="onSubmit()">
                  {{ isEditMode ? 'Update' : 'Save' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
